// extracted by mini-css-extract-plugin
module.exports = {"container":"amount-info_container__BUfG2","icon":"amount-info_icon__PKdSI","additionalInfo":"amount-info_additionalInfo__i13rD"};